import { getAddress } from '../../../utils/commonHelper';
import { nil } from '../../../utils/runOnceHelper';

const prepareLeadSellerName = (listing, handlePhoneCall, leadTranslate, showCloseButton) => {
  const { messages, t } = leadTranslate;
  const address = listing.contact?.address || {};
  const addressUrl = `https://maps.google.com/?q=${encodeURIComponent(
    getAddress(address)
  )}`;
  return {
    name: listing.contact?.name || '',
    address: getAddress(address),
    phoneNumber: listing.contact?.phone || '',
    linkContactInfo: true,
    addressLink: addressUrl,
    displayPhoneMessage: true,
    phoneText: t(messages.contactGroup?.phoneReveal),
    onClickPhoneMessage: handlePhoneCall,
    showCloseButton: showCloseButton
  };
};

const prepareLeadName = (
  idPrefix,
  name,
  leadTranslate,
  onChange = nil,
  onBlur = nil
) => {
  const { messages, t } = leadTranslate;
  return {
    id: `${idPrefix}name`,
    name: 'name',
    label: t(messages.contactForm.fullName),
    value: name,
    onChange,
    onBlur
  };
};

const prepareLeadEmail = (
  idPrefix,
  email,
  leadTranslate,
  onChange = nil,
  onBlur = nil
) => {
  const { messages, t } = leadTranslate;
  return {
    id: `${idPrefix}email`,
    name: 'email',
    label: t(messages.contactForm.email),
    value: email,
    onChange,
    onBlur
  };
};

const prepareLeadPhone = (idPrefix, phone, leadTranslate, onChange = nil, onBlur = nil, onChangePrefix = nil, featureFlagMandatoryPhone) => {
  const { messages, t } = leadTranslate;
  return {
    id: `${idPrefix}phone`,
    name: 'phone',
    label: featureFlagMandatoryPhone ? t(messages.contactForm.phone) : t(messages.contactForm.phoneOpt),
    value: phone,
    onChange,
    onBlur,
    onChangePrefix
  };
};

const prepareLeadTextarea = (
  idPrefix,
  message,
  leadTranslate,
  onChange = nil,
  onBlur = nil
) => {
  const { messages, t } = leadTranslate;
  return {
    label: t(messages.contactForm.comment),
    id: `${idPrefix}emailLeadForm`,
    name: 'text',
    value: message,
    onChange,
    onBlur
  };
};

  const bdpFormMessages = (t, messages) => {
  const successTitle = t(messages.contactForm.messageSentTitle);
  const successMessage = t(messages.additionalLeads.leadSuccessMessage);
  const errorMessage = t(messages.contactForm.messageError);
  const errorTitle = t(messages.contactForm.messageErrorTitle);
  const buttonLabel = t(messages.contactForm.contactButton);
  return {
    successTitle,
    successMessage,
    errorMessage,
    errorTitle,
    buttonLabel
  };
};

export {
  prepareLeadSellerName,
  prepareLeadName,
  prepareLeadEmail,
  prepareLeadPhone,
  prepareLeadTextarea,
  bdpFormMessages
};
